
import { ref } from 'vue'

import { fetchNationalAverage } from '../utils/fetch'

const nationalAverage = ref()

async function initNationalValue() {

  nationalAverage.value = await fetchNationalAverage()

}

initNationalValue()

export default nationalAverage